module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("This book is for anyone who has ever felt completely overwhelmed, stressed out, and burnt out. I hope this book provides a little boost to help you discover what the next small step forward i")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("s for you.")])])]), _vm._v(" "), _c('p', {
    staticClass: "ded1"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("Small steps add up, and you can figure th")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("ings out, ")])]), _c('span', {
    staticClass: "Italic"
  }, [_vm._v(" one small step ")]), _c('span', {
    staticClass: "noBreak"
  }, [_c('span', {
    staticClass: "Italic"
  }, [_vm._v("at a time.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f6f0221","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Dedication.vue
// module id = 69
// module chunks = 0